export default function applyUpdatersToResults(results, result, updaters) {
  return { ...results,
    ...Object.fromEntries(Object.entries(updaters).map(_ref => {
      let [fetchKey, updater] = _ref;
      return [fetchKey, updater(result, results[fetchKey])];
    }))
  };
}